import { useScriptGoogleTagManager, useScriptClarity, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const clarity = useScriptClarity({"id":"h5sfgs56ta"})
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-MSDVTKJ"})
    return { provide: { $scripts: { clarity, googleTagManager } } }
  }
})